import React from "react";

/**
 * ValuePropCards — Three cards showcasing speed, security, and Canadian identity.
 * Part of the pre-sign-in landing page.
 */
export const ValuePropCards: React.FC = () => {
  return (
    <div className="value-prop-cards" id="value-prop-cards">
      {/* Card 1: Speed & Simplicity */}
      <div className="value-prop-card" id="value-prop-speed">
        <div className="value-prop-card-icon" aria-hidden="true">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
            />
            <polyline
              points="12 6 12 12 16 14"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h3 className="value-prop-card-title">5 Minutes to Clarity</h3>
        <p className="value-prop-card-description">
          Answer a few quick questions about your savings, income, and goals.
          Our algorithm handles the rest.
        </p>
      </div>

      {/* Card 2: Security & Trust */}
      <div className="value-prop-card" id="value-prop-security">
        <div className="value-prop-card-icon" aria-hidden="true">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="3"
              y="11"
              width="18"
              height="11"
              rx="2"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M7 11V7a5 5 0 0110 0v4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <h3 className="value-prop-card-title">Secured by Google Cloud</h3>
        <p className="value-prop-card-description">
          Sign in with your existing Google, Apple, or Microsoft account. Your
          data is encrypted and stored in Canada.
        </p>
      </div>

      {/* Card 3: Canadian Identity */}
      <div className="value-prop-card" id="value-prop-canadian">
        <div className="value-prop-card-icon" aria-hidden="true">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2L9.5 8.5L3 9l5 4.5L6.5 20L12 16.5L17.5 20L16 13.5L21 9l-6.5-.5L12 2z"
              fill="currentColor"
            />
          </svg>
        </div>
        <h3 className="value-prop-card-title">Made for Your Situation</h3>
        <p className="value-prop-card-description">
          Every Canadian retirement program — built into the engine. Your
          retirement plan reflects your Canadian life.
        </p>
      </div>
    </div>
  );
};
